<template>
  <mdb-container fluid class="bodyimg">
    <mdb-row class="bodyimgrow">
      <mdb-col class="bodycol">
        <img class="bodyimg" src="/static/images/body/dontshade.png" />
      </mdb-col>
    </mdb-row>
 </mdb-container>
</template>

<script>
export default {
};
</script>

<style scoped>
.w-100 {
  max-width: 1900px !important;
}

.container-fluid {
  max-width: 1900px;
  padding-right: 0px;
  padding-left: 0px;
  margin-right: auto;
  margin-left: auto;
}

.bodyimg {
  max-width: 100%;
  height: auto;
}

.bodyimgrow {
  height: auto;
  max-width: 1900px;
  margin-right: auto;
  margin-left: auto;
  align-items: center;
}

.bodycol {
  height: auto;
  max-width: 1900px;
  margin-right: auto;
  margin-left: auto;
  align-items: center;
  padding: 0 0px;
}
</style>
